<template>
  <div>
    <PrimaryButton light dense shrink @click.native="openDialog">
      Edit
      <template v-slot:append:icon>
        <v-icon>mdi-pencil</v-icon>
      </template>
    </PrimaryButton>
    <EditQualificationDialog
      v-if="isOpen"
      :qualification="qualification"
      :isOpen="isOpen"
      @close="closeDialog"
    />
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import EditQualificationDialog from "@/views/profile/QuestionsAndAnswers/steps/Qualifications/dialogs/EditQualificationDialog";

export default {
  name: "EditQualificationAction",
  components: {
    PrimaryButton,
    EditQualificationDialog
  },
  data() {
    return {
      isOpen: false
    };
  },
  props: {
    qualification: Object
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
